import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stethoscope, Clock, UserCog, UserPlus, Calendar } from 'lucide-react';

const SettingsPanel = () => {
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>Podešavanja</h2>
            <p style={styles.hint}>Administracija tretmana, radnog vremena i doktora.</p>

            <div style={styles.grid}>
                <div style={styles.card} onClick={() => navigate('/services')}>
                    <Stethoscope size={48} color="#0ea5e9" />
                    <h3>Tretmani</h3>
                    <p>Dodavanje i izmena tipova tretmana i njihovog trajanja</p>
                </div>

                <div style={styles.card} onClick={() => navigate('/working-hours')}>
                    <Clock size={48} color="#ea580c" />
                    <h3>Radno vreme</h3>
                    <p>Unos radnog vremena ordinacije po nedeljama</p>
                </div>

                <div style={styles.card} onClick={() => navigate('/doctors')}>
                    <UserCog size={48} color="#0d9488" />
                    <h3>Doktori</h3>
                    <p>Dodavanje i izmena doktora u bazi</p>
                </div>
            </div>

            <h3 style={styles.subTitle}>Zastarele stranice</h3>
            <div style={styles.grid}>
                <div style={styles.card} onClick={() => navigate('/schedule')}>
                    <UserPlus size={48} color="#10b981" />
                    <h3>Novo Zakazivanje</h3>
                    <p>Pronađite slobodan termin i upišite pacijenta</p>
                </div>

                <div style={styles.card} onClick={() => navigate('/calendar')}>
                    <Calendar size={48} color="#1c8aa6" />
                    <h3>Kalendar</h3>
                    <p>Pregledajte zakazane termine po satnici</p>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: '900px',
        margin: '0 auto',
        padding: '15px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    title: { margin: '0 0 6px 0', fontSize: '24px', color: '#1f2937' },
    hint: { fontSize: '13px', color: '#7f8c8d', marginBottom: '25px' },
    subTitle: { margin: '35px 0 15px 0', fontSize: '16px', color: '#7f8c8d' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' },
    card: {
        background: '#fff', padding: '25px', borderRadius: '15px', textAlign: 'center',
        cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.2s',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)', border: '1px solid #e2e8f0'
    }
};

export default SettingsPanel;
